import { render, staticRenderFns } from "./DeliveryRequests.vue?vue&type=template&id=70e85257&scoped=true"
import script from "./DeliveryRequests.vue?vue&type=script&lang=js"
export * from "./DeliveryRequests.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRequests.vue?vue&type=style&index=0&id=70e85257&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e85257",
  null
  
)

export default component.exports